import { css } from "@emotion/css";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const cell = css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;

    width: 100%;

    color: ${Colors.Black.V100};
`;

export const cellFlexStart = css`
    align-items: flex-start;
`;

export const cellValue = css`
    ${Fonts.Paragraph.P300};
    display: block;
`;

export const cellPercent = css`
    ${Fonts.Heading.H900};
    display: block;
    color: ${Colors.Black.V50};
`;

export const cellHeader = css`
    ${Fonts.Heading.H700};
    display: block;
    color: ${Colors.Black.V100};
`;
export const cellHighlighted = css`
    background-color: ${Colors.Gray.V100};
`;
